<template>
<v-layout row wrap>
  <v-flex :class='col1layoutclasses' >
    <v-card :dark='dark' flat tile height="100%" >
      <v-window v-model="window" vertical touchless >
        <v-window-item >
          <appointment-filters
            v-model='filters'
            :relationship='relationship'
            :page-size.sync='pageSize'
            :initial-relationship='relationship'
            :facets='facets'
            :mini='mini'
            :clear-date-range='clearDateRange'
            :withClose='compact'
            @close='window++'
            :attrs='{dark: dark, flat:true}' >
            <template slot='actions' >
              <v-card-actions
                v-if='compact'
                class='pa-0' >
                <v-btn @click='window++' block >
                  Show appointments
                </v-btn>
              </v-card-actions>
            </template>
          </appointment-filters>
        </v-window-item >

        <v-window-item v-if='compact' >
          <appointment-list
            :attrs="{height: '100%', flat: true}"
            :dense='dense'
            :page-size='pageSize'
            :group-by-name='true'
            :with-subheaders='true'
            :with-actions='true'
            :selected.sync='selected'
            :request.sync='request'
            :params='filters'
            :list-attrs="{withActions:true,withAction:false}"
            facets='practitioner,space,address,status'
            @count='setCount' >
            <v-btn slot='toolbar-before' icon
              @click='window=0' >
              <v-icon>filter_list</v-icon>
            </v-btn>
          </appointment-list>
        </v-window-item>
      </v-window>
    </v-card>
  </v-flex>
  <v-flex
    v-if="!compact"
    xs12 sm7 md7 lg9 style='border-left: 1px solid #ccc;' class="pa-0" >
    <v-card tile flat height="100%" >
      <appointment-list
        v-if='filters'
        :dense='dense'
        :initial-page-size='pageSize'
        :group-by-name=true
        :with-subheaders='true'
        :with-actions='true'
        :selected.sync='selected'
        :request.sync='request'
        :params='filters'
        :ordering='ordering'
        :list-attrs="{withActions:true,withAction:false,withPricing:true}"
        facets='practitioner,space,address,status' >

        <v-btn
          v-if='withFullscreen'
          slot='toolbar-end'
          @click='toggleFullScreen' icon small >
          <v-icon small v-if='fullscreen' >close_fullscreen</v-icon>
          <v-icon small v-else >fullscreen</v-icon>
        </v-btn>
      </appointment-list>
    </v-card>
  </v-flex>
</v-layout>
</template>

<script>
import AppointmentFilters from '@/components/filters/AppointmentFilters.vue'
import AppointmentList from '@/components/lists/AppointmentList.vue'

export default {
  name: 'AppointmentPicker',
  components: {
    AppointmentList,
    AppointmentFilters
  },
  props: {
    value: { required: false },
    relationship: {type: Object},
    initialWindow: {type: Number, default: 0},
    fetchTrigger: {type: Number, default: 0},
    ordering: { type: String, default: 'client_id,relationships,practitioner_id,-start_time' },
    clearDateRange: {type: Boolean, default: false},
    compact: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    initialPageSize: { type: Number, default: 20 },
    withFullscreen: { type: Boolean, default: false },
    withRelationshipQuickPick: { type: Boolean, default: false },
    fullscreen: { type: Boolean, default: false },
    withPrice: { type: Boolean, default: false },
    withSelectAction: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    mini: { type: Boolean, default: false }
  },
  data () {
    return {
      window: 0,
      datepickervisible: false,
      selectedItem: null,
      appointments: [],
      selected: [],
      numResults: null,
      pageSize: 20,
      client: {},
      request: { status: 0 },
      filters: {}
    }
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
    },
    relationshipId () {
      if (this.relationshipId && this.initialWindow > 0) {
        this.window = this.initialWindow
      }
    },
    requestStatus () {
      if (this.requestStatus > 0) { this.$emit('ready') }
    },
    fetchTrigger () {
      this.get()
    }
  },
  computed: {
    facets () {
      return this.getObjectPath(this.request, 'result.facets', {})
    },
    relationshipId () {
      if (this.relationship && this.relationship.id) { return this.relationship.id }
      return null
    },
    col1layoutclasses () {
      let classes = []
      if (this.compact === true) {
        classes = ['xs12']
      } else {
        classes = ['xs12', 'sm5', 'md5', 'lg3']
      }
      if (this.$vuetify.breakpoint.smAndUp) {
        classes.push('pa-0')
      }
      return classes
    },
    requestStatus () {
      return this.request.status
    }
  },
  mounted () {
    if (this.compact) {
      this.window = 0
      if (this.initialWindow > 0) {
        this.window = this.initialWindow
      }
    }
    if (this.initialPageSize) { this.pageSize = this.initialPageSize }
  },
  methods: {
    setCount (cnt) {
      this.numResults = cnt
    },
    toggleFullScreen () {
      let fs = !this.fullscreen
      this.$emit('update:fullscreen', fs)
    },
    get () {
      this.$request('get', this.request)
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Select appointments',
        daterange: {
          subtitle: 'Change active date range'
        },
        client: {
          subtitle: 'Selected client'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// index.vue?7387b81b